export * from './lib/confirm-modal.module';
export { ConfirmModalService } from './lib/services/confirm-modal.service';
